<template>
    <div class="text-center">
        <img src="../assets/images/logo_s.svg" class="pic">
    </div>
</template>

<script>

    import * as mutationTypes from "@/store/mutationTypes";

    export default {
        name: "Redirection",
        data() {
            return {
                dataToken: this.$route.query.dataToken !== undefined ? this.$route.query.dataToken : "",
                dataObject: {},
            }
        },
        created() {
            try {
                this.$router.replace({ query: {} })

                this.dataObject = this.$crypto.uriComponentToObject(this.dataToken)
                if ((this.dataObject.usedType === "webGetCoupon" && this.dataObject.id > 0) ||
                    (this.dataObject.uri === "web-store-info" &&
                        (this.dataObject.usedType === "webIndex" || this.dataObject.usedType === "reward-point" ||
                            this.dataObject.usedType === "member" ||this.dataObject.usedType === "loyalty-card" ||
                            this.dataObject.usedType === "coupon" || this.dataObject.usedType === "oin-card") &&
                        (this.dataObject.storeCode !== undefined && this.dataObject.storeCode !== ""))
                ) {
                    if (this.dataObject.isLine && this.dataObject.lineUserId !== "") {
                        this.checkLineInfo()
                    } else {
                        this.goLogin('', '', '', '', 0, "", this.dataToken)
                    }
                } else {
                    this.$router.push({name:'Error'});
                }
            } catch (e) {
                this.$router.push({name:'Error'});
            }
        },
        methods: {
            goLogin(tel = '', password = '', countryCode = '', countryName = '', id = 0, message = '', dataToken) {
                let routerName = "Login"

                sessionStorage.setItem("loginToken", this.$crypto.objectToURIComponent({
                    "usedType": routerName,
                    "tel": tel,
                    "password": password,
                    "countryName": countryName,
                    "countryCode": countryCode,
                    "isLine": this.dataObject.isLine || false,
                    "uId": id,
                    "message": message,
                }))

                if (this.dataObject.isLine === true && this.dataObject.isShowPullDownScan === 1){
                    sessionStorage.setItem("isShowPullDownScan", true);
                    sessionStorage.setItem("isLine", this.dataObject.isLine);
                }

                this.$router.push({name: routerName, query: {dataToken: dataToken}})
            },
            checkLineInfo() {
                this.$http.fetchWithEncrypt`VerifyLine${{
                    "isLine": this.dataObject.isLine || false,
                    "lineBasicId": this.dataObject.botId || '',
                    'lineUserId': this.dataObject.lineUserId || '',
                    'time': this.$public.dateFormat('yyyy-MM-dd hh:mm:ss'),
                }}
                ${json => {
                    if (json.status) {
                        let data = {}
                        try {
                            data = this.$crypto.decryptObjectText(json.data)
                        } catch (e) {
                            //
                        }

                        this.goLogin(data.tel || '', data.password || '', data.countryCode || '', data.countryName || '', data.id || 0, json.message || '', this.dataToken)
                    } else {
                        this.goLogin('', '', '', '', 0, "", this.dataToken)
                    }
                }}`
            },
        },
    }
</script>

<style scoped lang="less">
    .pic{
        width: 60px;
        margin: calc(50vh - 30px) auto 0;
    }
</style>
